import FormLinks from '@components/search/forms/FormLinksCustom'
import FormLinkCustom from '@components/search/forms/FormLinkCustom'

import styles from 'styles/FormLinkRadio.module.css'

const FormLinksRadio = (props) => <div className={styles.wrap}>
    <FormLinks {...props}
        LinkItem={FormLinkCustom}
        styles={styles} />
</div>

export default FormLinksRadio